import { BoardCardData } from "./types"

export class BoardCard {
  public id: string
  public type: BoardCardData["type"]
  public title: string
  public responsible: BoardCardData["responsible"]
  public color: string = "Default"
  public startDate: string | null = null
  public dueDate: string | null = null
  public position: number = 0
  public formattedSchedule: string | null = null
  public dueDateStatus: BoardCardData["dueDateStatus"] = "onTrack"
  public isCompleted: boolean = false
  public projectLink: BoardCardData["projectLink"] = null
  public customers: BoardCardData["customers"] = []
  public description: string | null = null

  static create(cardData: NewCardData): BoardCard {
    return new BoardCard({
      id: cardData.id,
      title: cardData.title,
      type: cardData.type,
      responsible: cardData.responsible ?? [],
      color: cardData.color ?? "Default",
      startDate: cardData.startDate ?? null,
      dueDate: cardData.dueDate ?? null,
      position: cardData.position ?? 0,
      formattedSchedule: cardData.formattedSchedule ?? null,
      dueDateStatus: cardData.dueDateStatus ?? "onTrack",
      isCompleted: cardData.isCompleted ?? false,
      projectLink: cardData.projectLink ?? null,
      customers: cardData.customers ?? [],
      description: cardData.description ?? null,
    })
  }

  static fromData(cardData: BoardCardData): BoardCard {
    return new BoardCard(cardData)
  }

  private constructor(cardData: BoardCardData) {
    this.id = cardData.id
    this.type = cardData.type
    this.title = cardData.title
    this.responsible = cardData.responsible
    this.color = cardData.color
    this.startDate = cardData.startDate
    this.dueDate = cardData.dueDate
    this.position = cardData.position
    this.formattedSchedule = cardData.formattedSchedule
    this.dueDateStatus = cardData.dueDateStatus
    this.isCompleted = cardData.isCompleted
    this.projectLink = cardData.projectLink
    this.customers = cardData.customers
    this.description = cardData.description
  }

  toObject(): BoardCardData {
    return {
      id: this.id,
      type: this.type,
      title: this.title,
      description: this.description,
      responsible: this.responsible,
      color: this.color,
      startDate: this.startDate,
      dueDate: this.dueDate,
      position: this.position,
      formattedSchedule: this.formattedSchedule,
      dueDateStatus: this.dueDateStatus,
      isCompleted: this.isCompleted,
      projectLink: this.projectLink,
      customers: this.customers,
    }
  }
}

type NewCardData = {
  id: string
  title: string
  type: BoardCardData["type"]
  position?: number
} & Partial<BoardCardData>
